export const isExternalUrl = (url: string) => {
  if (!url.startsWith('http://') && !url.startsWith('https://') && !url.startsWith('//'))
    return false;

  const host = new URL(url.startsWith('http') ? url : `http:${url}`).hostname.replace('www.', '');

  return host !== 'modaoperandi.com';
};
